module.exports = __webpack_public_path__ + "images/category_lp/smartwatch/assessment_achievements/1_2e78669be64da3d3549119b37c2f4777.jpg";